import type { SVGProps } from 'react'
const SvgHorizontalSplitter = (props: SVGProps<SVGSVGElement>) => (
    <svg width="218" height="2" viewBox="0 0 218 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <line y1="1.05664" x2="218" y2="1.05664" stroke="#E3E3E3"/>
    </svg>
    
)
export default SvgHorizontalSplitter
